import $ from 'jquery';
import { Popover } from 'bootstrap';
import '../sass/site.scss';
import { OnetimeGift } from './modules/onetimegift';
import { MemoryGift } from './modules/memorygift';
import { CelebrationGift } from './modules/celebrationgift';
import { Newsletter } from './modules/newsletter';
import { SearchForm } from './modules/search';
import { initDonationCommon } from './modules/donationcommon';
import { initSidebarNavigation } from './modules/sidebarnavigation';
import { initStickyHeader } from './modules/stickyheader';
import { initParentStickyTop } from './modules/parentstickytop';
import { initMobileCarousel } from './modules/mobilecarousel';
import { initPagination } from './modules/pagination';
import { initFileUpload } from './modules/fileupload';
import { initShareLink } from './modules/sharelink';
import { initTooltips } from './modules/tooltips';

window.$ = window.jQuery = $;

$(() => {
    initDonationCommon();

    // Portade fran FrontendSrc/patternlab/js/, som slutade bundlas nar bygget
    // gick fran Gulp till Vite - Gulp konkatenerade in hela den katalogen via
    // globen patternlab/js/**/*.js, Vite tar bara det som importeras harifran.
    initSidebarNavigation();
    initStickyHeader();
    initParentStickyTop();
    initMobileCarousel();
    initPagination();
    initFileUpload();
    initShareLink();
    initTooltips();

    $('.onetimegift').each((_idx, item) => {
        const ot = new OnetimeGift(item as HTMLElement);
        ot.initEvents();
    });

    $('.memorygift').each((_idx, item) => {
        const mg = new MemoryGift(item as HTMLElement);
        mg.initEvents();
    });

    $('.celebrationgift').each((_idx, item) => {
        const cg = new CelebrationGift(item as HTMLElement);
        cg.initEvents();
    });

    $('.newsletter-block').each((_idx, item) => {
        new Newsletter(item as HTMLElement);
    });

    const searchForm = document.getElementById('searchform');
    if (searchForm) {
        new SearchForm(searchForm);
    }

    // Bootstrap popovers are opt-in and must be initialised explicitly. Used e.g. for the
    // "?" tax-reduction help on the donation form. Content comes from Umbraco dictionary
    // items (HTML), so enable html rendering. The trigger (focus) is read from markup.
    document.querySelectorAll<HTMLElement>('[data-bs-toggle="popover"]').forEach(el => {
        Popover.getOrCreateInstance(el, { html: true });
    });
});
